import React from 'react';
import { MessageCircle, Globe, ArrowRight } from 'lucide-react';

const QuickActionsBar = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openMultilingual = () => {
    const trigger = document.querySelector('.multilingual-trigger');
    if (trigger) {
      trigger.click();
    }
  };

  const openChatbot = () => {
    // Approche directe : chercher le bouton ChatBot et cliquer dessus
    // Le ChatBot Sophie est en position fixe bottom-6 left-6
    const chatbotButton = document.querySelector('button.fixed.bottom-6.left-6');
    
    if (chatbotButton) {
      chatbotButton.click();
      console.log('✅ ChatBot ouvert');
    } else {
      // Fallback : chercher par l'image alt
      const chatbotImg = document.querySelector('img[alt*="Conseiller"]');
      if (chatbotImg && chatbotImg.closest('button')) {
        chatbotImg.closest('button').click();
        console.log('✅ ChatBot ouvert (fallback)');
      } else {
        console.error('❌ Bouton ChatBot non trouvé');
        // Last resort: scroll en haut et attendre
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  // Ouvrir le modal VirtualAssistant
  const openVirtualAssistant = () => {
    window.dispatchEvent(new Event('openVirtualAssistant'));
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 py-6">
      <div className="max-w-7xl mx-auto px-4">
        {/* Desktop: 3 boutons horizontaux */}
        <div className="hidden md:flex items-center justify-center space-x-6">
          {/* Bouton 1: Speak Your Language */}
          <button
            onClick={openMultilingual}
            className="group flex items-center space-x-3 bg-white text-gray-800 px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border-4 border-green-400"
          >
            <Globe className="text-green-600" size={28} />
            <span className="font-bold text-lg">🌐 Speak Your Language</span>
          </button>

          {/* Bouton 2: Expliquez votre demande */}
          <button
            onClick={openChatbot}
            className="group flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            <MessageCircle size={28} />
            <span className="font-bold text-lg">💬 Expliquez votre demande ici</span>
          </button>

          {/* Bouton 3: Découvrir nos services */}
          <button
            onClick={openVirtualAssistant}
            className="group flex items-center space-x-3 bg-white text-gray-800 px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border-4 border-blue-400"
          >
            <span className="text-2xl">🔧</span>
            <span className="font-bold text-lg">Découvrir nos services</span>
          </button>
        </div>

        {/* Mobile: Boutons empilés */}
        <div className="flex md:hidden flex-col space-y-4">
          <button
            onClick={openMultilingual}
            className="flex items-center justify-center space-x-3 bg-white text-gray-800 px-6 py-4 rounded-full shadow-xl"
          >
            <Globe className="text-green-600" size={24} />
            <span className="font-bold">🌐 Speak Your Language</span>
          </button>

          <button
            onClick={openChatbot}
            className="flex items-center justify-center space-x-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-4 rounded-full shadow-xl"
          >
            <MessageCircle size={24} />
            <span className="font-bold">💬 Expliquez votre demande</span>
          </button>

          <button
            onClick={openVirtualAssistant}
            className="flex items-center justify-center space-x-3 bg-white text-gray-800 px-6 py-4 rounded-full shadow-xl"
          >
            <span className="text-xl">🔧</span>
            <span className="font-bold">Découvrir nos services</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsBar;
